import ExecutionEnvironment from 'exenv';
import GroupButton from './GroupButton.js';
import PropTypes from 'prop-types';
import React from 'react';
import { TypeNames } from './constants.js';
import { SelectGroupContainer } from './styles.js';
import { SingleSelectGroupSize, SingleSelectGroupType } from './types.js';
import { ThemingContext } from '@doordash/design-language';
import { getPropsToForward } from '@doordash/utilities';
import invariant from 'invariant';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var KEYCODES = {
  DOWN: 40,
  LEFT: 37,
  RIGHT: 39,
  UP: 38
}; // TODO(lindsey-menges): rename to `ButtonToggleGroup` in v7

var SingleSelectGroup = /*#__PURE__*/function (_React$Component) {
  _inherits(SingleSelectGroup, _React$Component);

  var _super = _createSuper(SingleSelectGroup);

  function SingleSelectGroup() {
    var _this;

    _classCallCheck(this, SingleSelectGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "rootElement", /*#__PURE__*/React.createRef());

    _defineProperty(_assertThisInitialized(_this), "state", {
      selectedIndex: null
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
      var type = event.type;
      var optionCount = React.Children.count(_this.props.children) || (Array.isArray(_this.props.options) ? _this.props.options.length : 0);

      if (type === 'keydown' && typeof _this.state.selectedIndex === 'number') {
        switch (event.keyCode) {
          case KEYCODES.DOWN:
          case KEYCODES.RIGHT:
            return _this.setSelectedIndex((_this.state.selectedIndex + 1) % optionCount);

          case KEYCODES.UP:
          case KEYCODES.LEFT:
            return _this.setSelectedIndex(_this.state.selectedIndex === 0 ? optionCount - 1 : _this.state.selectedIndex - 1);

          default:
            return null;
        }
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "focusOnChild", function (index) {
      if (ExecutionEnvironment.canUseDOM && _this.rootElement.current && typeof index === 'number') {
        Array.from(_this.rootElement.current.childNodes)[index].focus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setSelectedIndex", function (index) {
      _this.setState({
        selectedIndex: index
      });

      _this.focusOnChild(index);

      if (_this.props.onChange) {
        _this.props.onChange(index);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "isSelectedIndex", function (index) {
      return index === _this.props.selectedIndex || index === _this.state.selectedIndex;
    });

    _defineProperty(_assertThisInitialized(_this), "propsForChild", function (child, index) {
      var isSelected = _this.isSelectedIndex(index);

      var childProps;

      if (typeof child === 'string') {
        childProps = {
          'aria-checked': isSelected,
          role: 'radio'
        };
      } else {
        childProps = {
          accessibilityRole: 'radio',
          'aria-checked': isSelected,
          isToggleable: true,
          isInline: true,
          isInRadioGroup: true,
          isToggled: isSelected,
          size: _this.props.size
        };
      }

      return _objectSpread(_objectSpread({}, childProps), {}, {
        onClick: function onClick(event) {
          if (_this.props.isDisabled) ; else {
            if (_this.props.shouldDeselectOnClick && (typeof _this.props.selectedIndex === 'number' || typeof _this.state.selectedIndex === 'number') && (_this.props.selectedIndex === index || _this.state.selectedIndex === index)) {
              _this.setSelectedIndex(null);
            } else {
              _this.setSelectedIndex(index);
            }

            if (child && child.props && child.props.onClick) {
              child.props.onClick(event);
            }
          }
        }
      });
    });

    return _this;
  }

  _createClass(SingleSelectGroup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.defaultSelectedIndex !== undefined) {
        this.setState({
          selectedIndex: this.props.defaultSelectedIndex
        });
      } else if (this.props.selectedIndex !== undefined) {
        this.setState({
          selectedIndex: this.props.selectedIndex
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.selectedIndex !== prevProps.selectedIndex) {
        // our component can be used as both a controlled and uncontrolled
        // component so we have to sync state, sorry ESLint
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          selectedIndex: this.props.selectedIndex
        });
      }

      if (prevProps.type !== this.props.type) {
        if (this.props.type === SingleSelectGroupType.PrimaryPill || this.props.type === SingleSelectGroupType.SecondaryPill || this.props.type === SingleSelectGroupType.TertiaryPill) {
          // eslint-disable-next-line no-console
          console.warn('Warning! `Pill` type Buttons will be removed in Prism Web v7 - we recommend changing your type to the non-pill equivalent');
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          initialChildren = _this$props.children,
          isDisabled = _this$props.isDisabled,
          _this$props$isInline = _this$props.isInline,
          isInline = _this$props$isInline === void 0 ? false : _this$props$isInline,
          options = _this$props.options,
          onChange = _this$props.onChange,
          accessibilityLabel = _this$props.accessibilityLabel,
          accessibilityLabeledBy = _this$props.accessibilityLabeledBy,
          accessibilityDescribedBy = _this$props.accessibilityDescribedBy;
          _this$props.selectedIndex;
          _this$props.shouldDeselectOnClick;
          _this$props.defaultSelectedIndex;
          var _this$props$size = _this$props.size,
          size = _this$props$size === void 0 ? SingleSelectGroupSize.Small : _this$props$size,
          _this$props$type = _this$props.type,
          type = _this$props$type === void 0 ? SingleSelectGroupType.Primary : _this$props$type,
          props = _objectWithoutProperties(_this$props, ["children", "isDisabled", "isInline", "options", "onChange", "accessibilityLabel", "accessibilityLabeledBy", "accessibilityDescribedBy", "selectedIndex", "shouldDeselectOnClick", "defaultSelectedIndex", "size", "type"]);

      invariant(!(typeof onChange === 'undefined'), "\n      You must provide an onChange method for SingleSelectGroup.\n    ");
      invariant(accessibilityLabeledBy && accessibilityLabeledBy.length || accessibilityLabel && accessibilityLabel.length, "\n      You must provide either an accessibilityLabel or a accessibilityLabeledBy prop that\n      references the ID of a label describing this SingleSelectGroup.\n    ");
      var children = null;

      if (initialChildren && React.Children.count(initialChildren) > 0) {
        children = React.Children.map(initialChildren, function (child, index) {
          return /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread({}, props), _this2.propsForChild(child, index)));
        });
      } else if (options && options.length && !options.some(function (option) {
        return typeof option !== 'string';
      })) {
        children = options.map(function (option, index) {
          return /*#__PURE__*/React.createElement(GroupButton, {
            key: index,
            buttonElementProps: _objectSpread(_objectSpread({}, getPropsToForward({
              props: props,
              prefixesToForward: ['data-', 'aria-']
            })), _this2.propsForChild(option, index)),
            index: index,
            isDisabled: isDisabled,
            isInline: isInline,
            isSelected: _this2.isSelectedIndex(index),
            option: option,
            kind: TypeNames[type],
            size: size
          });
        });
      }

      return /*#__PURE__*/React.createElement(SelectGroupContainer, {
        themeColors: this.context.Colors,
        kind: TypeNames[type],
        isDisabled: isDisabled,
        isInline: isInline,
        selectedIndex: this.state.selectedIndex,
        size: size,
        role: "radiogroup",
        "aria-label": accessibilityLabeledBy ? undefined : accessibilityLabel,
        "aria-labelledby": !(accessibilityLabeledBy && accessibilityLabeledBy.length) ? undefined : accessibilityLabeledBy,
        "aria-describedby": accessibilityDescribedBy,
        onKeyDown: this.onKeyDown,
        ref: this.rootElement
      }, children);
    }
  }]);

  return SingleSelectGroup;
}(React.Component);

_defineProperty(SingleSelectGroup, "contextType", ThemingContext);

_defineProperty(SingleSelectGroup, "Sizes", SingleSelectGroupSize);

_defineProperty(SingleSelectGroup, "Types", SingleSelectGroupType);

_defineProperty(SingleSelectGroup, "propTypes", {
  children: PropTypes.node,
  size: PropTypes.oneOf(Object.values(SingleSelectGroupSize)),
  type: PropTypes.oneOf(Object.values(SingleSelectGroupType)),
  onChange: PropTypes.func.isRequired,
  selectedIndex: PropTypes.number,
  defaultSelectedIndex: PropTypes.number,
  options: PropTypes.arrayOf(PropTypes.string),
  isInline: PropTypes.bool,
  shouldDeselectOnClick: PropTypes.bool,
  accessibilityLabel: PropTypes.string,
  accessibilityLabeledBy: PropTypes.string,
  accessibilityDescribedBy: PropTypes.string,
  isDisabled: PropTypes.bool
});

_defineProperty(SingleSelectGroup, "defaultProps", {
  type: SingleSelectGroupType.Primary,
  size: SingleSelectGroupSize.Small,
  isInline: false
});

export { SingleSelectGroup as default };
